import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import View from '@bubble-ui/primitive-view';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useDesignContext } from '@klarna/designtokens';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { defaultDesignTokens } from './defaultDesignTokens';
var size = _ref => {
  var {
    extraExtraSmall,
    extraSmall,
    medium,
    small,
    large,
    extraLarge,
    extraExtraLarge
  } = _ref;
  return extraExtraLarge ? 90 : extraLarge ? 70 : large ? 50 : medium ? 30 : small ? 15 : extraSmall ? 10 : extraExtraSmall ? 5 : 0;
};
export var OverridableSpacerVertical = props => {
  usePropDeprecationWarning({
    componentName: 'SpacerVertical',
    propName: 'extraExtraSmall',
    shouldWarn: props.extraExtraSmall !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerVertical',
    propName: 'extraSmall',
    shouldWarn: props.extraSmall !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerVertical',
    propName: 'medium',
    shouldWarn: props.medium !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerVertical',
    propName: 'small',
    shouldWarn: props.small !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerVertical',
    propName: 'large',
    shouldWarn: props.large !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerVertical',
    propName: 'extraLarge',
    shouldWarn: props.extraLarge !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerVertical',
    propName: 'extraExtraLarge',
    shouldWarn: props.extraExtraLarge !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  var designVersion = useDesignVersion();
  var designContext = useDesignContext(defaultDesignTokens);
  var sizeValue = props.spaceToken ? designContext.get(props.spaceToken).value() : size(props);

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var styleSheet = useStyleSheet(OverridableSpacerVertical, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    sizeValue,
    visible: props.visible,
    designContext,
    designVersion
  }));
  return /*#__PURE__*/React.createElement(View, {
    style: styleSheet.rootStyle
  });
};
OverridableSpacerVertical.displayName = 'SpacerVertical';
export default withProvisionalOverrideFromContext(OverridableSpacerVertical);
//# sourceMappingURL=index.js.map